import api from '../utilBackoffice';

const controller = 'Comissionamento';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => api.Axios.GetParams(url + '/Listar', dto),
  Create: dto => api.Axios.Post(url, dto),
  Update: dto => api.Axios.Post(url + '/Atualiza', dto),
  Delete: dto => api.Axios.Post(url + '/Delete', dto),
  Recalcular: dto => api.Axios.Post(url + '/Recalcular', dto),
  GetHistoricoSemVigencia: dto =>
    api.Axios.GetParams(url + '/HistoricoSemVigencia', dto),
  GetHistoricoComVigencia: dto =>
    api.Axios.GetParams(url + '/HistoricoComVigencia', dto),
  GetHistoricoComVigenciaDetalhe: dto =>
    api.Axios.GetParams(url + '/HistoricoComVigencia/Detalhes', dto),
  ListarParametrizados: dto =>
    api.Axios.GetParams(url + '/ListarParametrizados', dto),
  UpdatePeriodicidade: (codigo, dto) =>
    api.Axios.Put(url + '/UpdatePeriodicidade', codigo, dto),
  ExportarParametros: dto =>
    api.Axios.DownloadExcelFile(url + '/ExportarParametros', dto),
  RequisitarRelatorio: dto =>
    api.Axios.Post(url + '/Requisitar/Relatorio', dto),
  DownloadRelatorio: dto =>
    api.Axios.DownloadExcelFile(url + '/DownloadArquivoRelatorio', dto)
});
